import { Link } from "react-router-dom";
import styled from "styled-components";

export const ContacSupportContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px;
`;

export const ContacSupportCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  border: 1px solid ${({ theme }) => theme.colors.link.text};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.primary};
  width: 100vw;
  height: fit-content;
  padding: 15px;
`;

export const ContacSupportList = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-block: 10px;
`;

export const ContacSupportLink = styled(Link)`
  display: flex;
  justify-content: center;
  margin-left: auto;
  background-color: #7b36ee;
  color: #fff;
  padding-block: 6px;
  width: 50%;
`;
